import { lazy, Suspense } from 'react';

// Loaded on demand so the Wallet page doesn't grow the main (trading) bundle.
const WalletView = lazy(() => import('./wallet/WalletView'));

export function WalletPage() {
  return (
    <Suspense fallback={null}>
      <WalletView />
    </Suspense>
  );
}
